import { graphql } from ':src/graphql';

export const createOrganizationProgramMutation = graphql(`
  mutation CreateOrganizationProgramMutation($input: CreateOrganizationProgramInput!) {
    createOrganizationProgram(input: $input) {
      success
    }
  }
`);

export const deleteOrganizationProgramMutation = graphql(`
  mutation DeleteOrganizationProgramMutation($input: DeleteOrganizationProgramInput!) {
    deleteOrganizationProgram(input: $input) {
      success
      error
    }
  }
`);

export const updateSuperviseesInProgramMutation = graphql(`
  mutation UpdateSuperviseesInProgramMutation($input: UpdateSuperviseesInProgramInput!) {
    updateSuperviseesInProgram(input: $input) {
      success
    }
  }
`);

export const assignOrganizationProgramDirectorMutation = graphql(`
  mutation AssignOrganizationProgramDirectorMutation(
    $input: AssignOrganizationProgramDirectorInput!
  ) {
    assignOrganizationProgramDirector(input: $input) {
      success
    }
  }
`);

export const updateOrganizationProgramSettingsMutation = graphql(`
  mutation UpdateOrganizationProgramSettingsMutation(
    $input: UpdateOrganizationProgramSettingsInput!
  ) {
    updateOrganizationProgramSettings(input: $input) {
      success
    }
  }
`);
